import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Chip from '@zenbusiness/zui/Chip';
import Stack from '@zenbusiness/zui/Stack';
import { styled, superstyled } from '@zenbusiness/zui/styles';

export const CardContentStyled = superstyled({
  name: 'EnterpriseNextUpCard',
  slot: 'CardContent',
  tag: CardContent,
  propsNeeded: ['highlight'],
  styles: ({ theme, highlight }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    backgroundColor: highlight
      ? theme.palette.background.blue.light
      : theme.palette.fixed.white
  })
});

export const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  width: '5rem',
  backgroundColor: theme.palette.background.blue.light,
  borderRadius: theme.shape.rounded.full,

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    padding: theme.spacing(1.5)
  }
}));

export const CardContainer = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%'
}));

export const Content = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'space-between'
}));

export const LockedCard = styled(Card)(() => ({
  flex: 1,
  opacity: 0.5,
  pointerEvents: 'none'
}));

export const InteractiveCard = styled(Card)(() => ({
  flex: 1
}));

export const HighlightChip = superstyled({
  name: 'EnterpriseNextUpCard',
  slot: 'Chip',
  tag: Chip,
  propsNeeded: ['highlight'],
  styles: ({ theme, highlight }) => ({
    backgroundColor: highlight ? theme.palette.fixed.black : undefined,
    color: highlight ? theme.palette.fixed.white : undefined
  })
});
